module.exports = __webpack_public_path__ + "img/close-icon.f458a297.svg";